// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ListItem.module.scss  */
.ListItem-module-Container_2oo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px; }

.ListItem-module-AddonBefore_qiH {
  flex: 0 0 auto;
  margin-right: 16px; }

.ListItem-module-Main_1Lk {
  width: 100%;
  font-family: SBSansText;
  font-size: 1rem;
  line-height: 1.25; }

.ListItem-module-AddonAfter_1qF {
  display: inline-flex;
  flex: 0 0 40px;
  justify-content: center; }

.ListItem-module-isFilled_3rK {
  border-radius: var(--listitem-border-radius);
  background-color: var(--listitem-background-color); }

.ListItem-module-isOutlined_wiN {
  border: 1px solid var(--listitem-border-color);
  border-radius: var(--listitem-border-radius); }

.ListItem-module-isFilled_3rK,
.ListItem-module-isOutlined_wiN {
  box-sizing: border-box;
  padding: 16px; }
  .ListItem-module-isFilled_3rK label,
  .ListItem-module-isOutlined_wiN label {
    padding: 0; }

.ListItem-module-hasSeparator_2zR:not(:last-of-type):not(.ListItem-module-isFilled_3rK):not(.ListItem-module-isOutlined_wiN) {
  border-bottom: 1px solid var(--listitem-border-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/ListItem/ListItem.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB,EAAE;;AAEvB;EACE,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,iBAAiB,EAAE;;AAErB;EACE,oBAAoB;EACpB,cAAc;EACd,uBAAuB,EAAE;;AAE3B;EACE,4CAA4C;EAC5C,kDAAkD,EAAE;;AAEtD;EACE,8CAA8C;EAC9C,4CAA4C,EAAE;;AAEhD;;EAEE,sBAAsB;EACtB,aAAa,EAAE;EACf;;IAEE,UAAU,EAAE;;AAEhB;EACE,qDAAqD,EAAE","sourcesContent":["/*  imported from ListItem.module.scss  */\n.ListItem-module-Container_2oo {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 8px;\n  padding-bottom: 8px; }\n\n.ListItem-module-AddonBefore_qiH {\n  flex: 0 0 auto;\n  margin-right: 16px; }\n\n.ListItem-module-Main_1Lk {\n  width: 100%;\n  font-family: SBSansText;\n  font-size: 1rem;\n  line-height: 1.25; }\n\n.ListItem-module-AddonAfter_1qF {\n  display: inline-flex;\n  flex: 0 0 40px;\n  justify-content: center; }\n\n.ListItem-module-isFilled_3rK {\n  border-radius: var(--listitem-border-radius);\n  background-color: var(--listitem-background-color); }\n\n.ListItem-module-isOutlined_wiN {\n  border: 1px solid var(--listitem-border-color);\n  border-radius: var(--listitem-border-radius); }\n\n.ListItem-module-isFilled_3rK,\n.ListItem-module-isOutlined_wiN {\n  box-sizing: border-box;\n  padding: 16px; }\n  .ListItem-module-isFilled_3rK label,\n  .ListItem-module-isOutlined_wiN label {\n    padding: 0; }\n\n.ListItem-module-hasSeparator_2zR:not(:last-of-type):not(.ListItem-module-isFilled_3rK):not(.ListItem-module-isOutlined_wiN) {\n  border-bottom: 1px solid var(--listitem-border-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
